export default __webpack_public_path__ + "static/media/biz-individual.0934295f.svg";